/* eslint-disable @typescript-eslint/naming-convention */
export class CentralDatabaseKeys {
	public static readonly workFileId = 'workFileId';
	public static readonly workspaceName = 'workspaceName';
	public static readonly projects = 'projects';
	public static readonly fusionEntities = 'fusionEntities';
	public static readonly fusionConfigHeaders = 'fussionConfigHeaders';
	public static readonly fusionUsers = 'fusionUsers';
	public static readonly centraldatabase = 'centraldatabase';
	public static readonly workspaces = 'workspaces';
	public static readonly projectNumber = 'project_number';
	public static readonly importedUnix = 'importedUnix';
	public static readonly entityName = 'entity_name';
	public static readonly archived = 'archived';
	public static readonly pendingDelete = 'pendingDelete';
	public static readonly importedFromFile = 'importedFromFile';
	public static readonly userId = 'userid';
	public static readonly apiConnectionId = 'apiConnectionId';

	public static readonly tableInfo = 'tableinfos';
	public static readonly tableInfo_tableName = 'name';
	public static readonly tableInfo_tableType = 'tableType';

	public static readonly localCredentials = 'localcredentials';
	public static readonly localCredentials_username = 'username';
	public static readonly localCredentials_pin = 'pin';
	public static readonly localCredentials_failedAttempts = 'failedAttempts';

	public static readonly apiConnections = 'apiconnections';
	public static readonly apiConnections_connectionId = 'connectionId';
	public static readonly apiConnections_serverPath = 'serverPath';
	public static readonly apiConnections_apiKey = 'apiKey';
	public static readonly apiConnections_serverAlias = 'serverAlias';
	public static readonly apiConnections_selectedOptions = 'selectedOptions';
	public static readonly apiConnections_selectedOptions_database = 'database';
	public static readonly apiConnections_selectedOptions_businessUnit = 'businessUnit';
	public static readonly apiConnections_selectedOptions_sstnLoggingStyle = 'sstnLoggingStyle';
	public static readonly apiConnections_selectedOptions_dhlLoggingStyle = 'dhlLoggingStyle';

	public static readonly columnPrimaryKeyComposed = 'pk_composed';
	public static readonly columnSeparator = '_';
}
